import {
  getParamWithColon,
  UrlParamName,
} from 'hooks/navigation/useAppUrlParams';

export const organizationIdParam = getParamWithColon(
  UrlParamName.ORGANIZATION_ID
);
export const projectIdParam = getParamWithColon(UrlParamName.PROJECT_ID);
export const siteIdParam = getParamWithColon(UrlParamName.SITE_ID);
export const userIdParam = getParamWithColon(UrlParamName.USER_ID);
export const inspectionTemplateIdParam = getParamWithColon(
  UrlParamName.INSPECTION_TEMPLATE_ID
);
export const chartIdParam = getParamWithColon(UrlParamName.CHART_ID);
export const companyIdParam = getParamWithColon(UrlParamName.COMPANY_ID);
export const contractIdParam = getParamWithColon(UrlParamName.CONTRACT_ID);
export const customizedFieldNameParam = getParamWithColon(
  UrlParamName.CUSTOMIZED_FIELD_NAME
);
export const issueIdParam = getParamWithColon(UrlParamName.ISSUE_ID);
export const eventIdParam = getParamWithColon(UrlParamName.EVENT_ID);
export const decisionIdParam = getParamWithColon(UrlParamName.DECISION_ID);
export const documentIdParam = getParamWithColon(UrlParamName.DOCUMENT_ID);

export const linkedDocumentationVersionIdParam = getParamWithColon(
  UrlParamName.LINKED_DOCUMENTATION_VERSION_ID
);
export const checklistItemIdParam = getParamWithColon(
  UrlParamName.CHECKLIST_ITEM_ID
);
export const directoryIdParam = getParamWithColon(
  UrlParamName.DIRECTORY_ID
);
export const fileIdParam = getParamWithColon(UrlParamName.FILE_ID);
export const inspectionIdParam = getParamWithColon(
  UrlParamName.INSPECTION_ID
);
export const protocolIdParam = getParamWithColon(
  UrlParamName.PROTOCOL_ITEM_ID
);
export const sectionIdParam = getParamWithColon(UrlParamName.SECTION_ID);
export const workflowIdParam = getParamWithColon(UrlParamName.WORKFLOW_ID);
